import React from "react";
import { Modal, Button } from "react-bootstrap";
import ReleaseNotesViewer from "./ReleaseNotesViewer";

// First-login release notes modal. Shown once per user after a release goes
// out; closing it (X or the footer button) marks the release as seen via the
// onClose handler wired in BootNav.
export default function ReleaseNotesModal({ show, release, onClose }) {
  if (!release) return null;

  return (
    <Modal show={show} onHide={onClose} centered size="xl" scrollable>
      <Modal.Header
        closeButton
        style={{ background: "#CFE2FF" }}
        className="rounded-0 text-primary d-flex align-items-center"
      >
        <Modal.Title as="h6" className="m-0">
          Release Notes — {release.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ReleaseNotesViewer release={release} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose} style={{ minWidth: 120 }}>
          Got it
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
